<template>
    <div class="agent-withdrawal-request-statistics">
        <b-card class="mb-4">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">
                        <i class="fas fa-chart-pie mr-2"></i>
                        {{ isAgent ? 'Моя статистика заявок на вывод средств' : 'Общая статистика заявок на вывод средств' }}
                    </h5>
                    <b-button 
                        size="sm" 
                        variant="outline-primary" 
                        @click="loadStatistics"
                        :disabled="loading"
                    >
                        <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
                        Обновить
                    </b-button>
                </div>
            </template>

            <div v-if="loading" class="text-center py-4">
                <b-spinner variant="primary"></b-spinner>
                <div class="mt-2">Загрузка статистики...</div>
            </div>

            <div v-else-if="error" class="alert alert-danger">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                {{ error }}
            </div>

            <div v-else class="statistics-grid">
                <div class="stat-card">
                    <div class="stat-content">
                        <div class="stat-label">Заявки созданы</div>
                        <div class="stat-value">
                            {{ (statistics.pending && statistics.pending.formatted) || '0,00 ₽' }}
                        </div>
                        <div class="stat-count" v-if="statistics.pending_count !== undefined">
                            {{ statistics.pending_count }} шт.
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-content">
                        <div class="stat-label">Акты сформированы</div>
                        <div class="stat-value">
                            {{ (statistics.act_generated && statistics.act_generated.formatted) || '0,00 ₽' }}
                        </div>
                        <div class="stat-count" v-if="statistics.act_generated_count !== undefined">
                            {{ statistics.act_generated_count }} шт.
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-content">
                        <div class="stat-label">Акты отправлены</div>
                        <div class="stat-value">
                            {{ (statistics.act_sent && statistics.act_sent.formatted) || '0,00 ₽' }}
                        </div>
                        <div class="stat-count" v-if="statistics.act_sent_count !== undefined">
                            {{ statistics.act_sent_count }} шт.
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-content">
                        <div class="stat-label">Акты получены</div>
                        <div class="stat-value">
                            {{ (statistics.act_received && statistics.act_received.formatted) || '0,00 ₽' }}
                        </div>
                        <div class="stat-count" v-if="statistics.act_received_count !== undefined">
                            {{ statistics.act_received_count }} шт.
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-content">
                        <div class="stat-label">Средства отправлены</div>
                        <div class="stat-value text-success">
                            {{ (statistics.funds_sent && statistics.funds_sent.formatted) || '0,00 ₽' }}
                        </div>
                        <div class="stat-count" v-if="statistics.funds_sent_count !== undefined">
                            {{ statistics.funds_sent_count }} шт.
                        </div>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-content">
                        <div class="stat-label">Отменено</div>
                        <div class="stat-value text-danger">
                            {{ (statistics.cancelled && statistics.cancelled.formatted) || '0,00 ₽' }}
                        </div>
                        <div class="stat-count" v-if="statistics.cancelled_count !== undefined">
                            {{ statistics.cancelled_count }} шт.
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 text-muted small">
                <i class="fas fa-info-circle mr-1"></i>
                Статистика за все время
            </div>
        </b-card>
    </div>
</template>

<script>
import { API_AGENT_WITHDRAWAL_REQUESTS } from "@/constants";

export default {
    name: 'AgentWithdrawalRequestStatistics',
    data() {
        return {
            loading: false,
            error: null,
            statistics: {},
            isAgent: false
        }
    },
    mounted() {
        this.loadStatistics();
    },
    methods: {
        loadStatistics() {
            this.loading = true;
            this.error = null;

            api.call('get', `${API_AGENT_WITHDRAWAL_REQUESTS}/statistics`)
                .then(response => {
                    if (response.data.success) {
                        this.statistics = response.data.data;
                        this.isAgent = response.data.is_agent || false;
                    } else {
                        this.error = response.data.message || 'Ошибка загрузки статистики';
                    }
                })
                .catch(error => {
                    console.error('Error loading statistics:', error);
                    this.error = 'Не удалось загрузить статистику. Попробуйте позже.';
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped>
.agent-withdrawal-request-statistics {
    margin-bottom: 2rem;
}

.statistics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: .7rem;
    margin-top: 1rem;
}

.stat-card {
    display: flex;
    align-items: center;
    padding: 1.2rem;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #dee2e6;
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-content {
    flex: 1;
}

.stat-label {
    font-size: 0.7rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
    font-weight: 500;
}

.stat-value {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.2;
}

.stat-count {
    font-size: 0.75rem;
    color: #6c757d;
    margin-top: 0.25rem;
}

@media (max-width: 768px) {
    .statistics-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
    
    .stat-card {
        padding: 1rem;
    }
    
    .stat-icon {
        width: 40px;
        height: 40px;
        font-size: 1.25rem;
    }
    
    .stat-value {
        font-size: 1.1rem;
    }
}
</style>

